export enum EDocumentCardModalTabKey {
    main,
    additional,
    tax,
    changesJournal
}

export const AIS_DOC_REGISTERS_DFF_NAME = 'ais.doc_journal';
